// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3UCg1","right":"styles_right__25G8U"};